export const PhoneFormat = (() => {
    const replaceStr = /[^\d]/g;

    const codeUnitedState = "+1";
    const codeMexico = "+52";
    const codeAustralia = "+61";
    const codeItaly = "+39";
    const codeColombia = "+57";
    const codeSpain = "+34";
    const codeChile = "+56";
    const codeUnitedKingdom = "+44";
    const codeArgentina = "+54";
    const codeBrazil = "+55";
    const codeVenezuela = "+58";
    const codeChina = "+86";
    const codeCuba = "+53";
    const codeGuatemala = "+502";
    const codeBolivia = "+591";
    const codeEcuador = "+593";
    const codeFrance = "+33";
    const codeUruguay = "+598";
    const codeCostaRica = "+506";
    const codePanama = "+507";
    const codeNicaragua = "+505";
    const codeHonduras = "+504";
    const codeElSalvador = "+503";
    const codePeru = "+51";
    const codeParaguay = "+595";
    const codeHaiti = "+509";
    const codeRussia = "+7";
    const codeGermany = "+49";
    const codeSwitzerland = "+41";

    const formatPhone = (phone) => {
        if(phone === null || phone === undefined || phone === "") return 
        const phoneStartWithBigger = phone.slice(0, 4);
        const phoneStartWith = phone.slice(0, 3);

        switch (phoneStartWithBigger) {
            case codeGuatemala:
            case codeCostaRica:
            case codePanama:
            case codeNicaragua:
            case codeHonduras:
            case codeElSalvador:
                return formatGuatemalaNumber(phone);

            case codeBolivia:
                return formatBoliviaNumber(phone);

            case codeEcuador:
                return formatEcuadorNumber(phone);

            case codeUruguay:
                return formatUruguayNumber(phone);

            case codeParaguay:
                return formatParaguayNumber(phone);

            case codeHaiti:
                return formatHaitiNumber(phone);

            default:
                break;
        }

        switch (phoneStartWith) {
            case codeMexico:
            case codeAustralia:
            case codeChina:
                return formatMexicanNumber(phone);

            case codeItaly:
            case codeVenezuela:
            case codeColombia:
                return formatItalyNumber(phone);

            case codeSpain:
            case codeChile:
                return formatSpainNumber(phone);

            case codeUnitedKingdom:
                return formatUnitedKingdomNumber(phone);

            case codeArgentina:
                return formatArgentineNumber(phone);

            case codeBrazil:
                return formatBrasilNumber(phone);

            case codeCuba:
                return formatCubaNumber(phone);

            case codeFrance:
                return formatFranceNumber(phone);

            case codePeru:
                return formatPeruNumber(phone);

            case codeGermany:
                return formatGermanyNumber(phone);

            case codeSwitzerland:
                return formatSwitzerlandNumber(phone);

            default:
                if (phoneStartWith.startsWith(codeUnitedState)) {
                    return formatDominicanNumber(phone);
                } else if (phoneStartWith.startsWith(codeRussia)) {
                    return formatRussiaNumber(phone);
                } else if (!phoneStartWith.startsWith("+")) {
                    return formatDominicanNumber(phone);
                } else {
                    return phone.slice(0, 15).replace(/[^\d+]/g, "");
                }
        }
    };

    const isValid = (phone) => {
        if(phone === null || phone === undefined || phone === "") return
        const phoneStartWithBigger = phone.slice(0, 4);
        const phoneStartWith = phone.slice(0, 3);

        switch (phoneStartWithBigger) {
            case codeGuatemala:
            case codeCostaRica:
            case codePanama:
            case codeNicaragua:
            case codeHonduras:
            case codeElSalvador:
                return phone.length >= 14;

            case codeBolivia:
                return phone.length >= 17;

            case codeEcuador:
                return phone.length >= 17;

            case codeUruguay:
                return phone.length >= 15;

            case codeParaguay:
                return phone.length >= 15;

            case codeHaiti:
                return phone.length >= 15;
            default:
                break;
        }

        switch (phoneStartWith) {
            case codeMexico:
            case codeAustralia:
            case codeChina:
                return phone.length >= 18;

            case codeItaly:
            case codeVenezuela:
            case codeColombia:
                return phone.length >= 15;

            case codeSpain:
            case codeChile:
                return phone.length >= 15;

            case codeUnitedKingdom:
                return phone.length >= 15;

            case codeArgentina:
                return phone.length >= 17;

            case codeBrazil:
                return phone.length >= 18;

            case codeCuba:
                return phone.length >= 13;

            case codeFrance:
                return phone.length >= 17;

            case codePeru:
                return phone.length >= 12;

            case codeGermany:
                return phone.length >= 15;

            case codeSwitzerland:
                return phone.length >= 16;

            default:
                if (phoneStartWith.startsWith(codeUnitedState)) {
                    return phone.length >= 17;
                } else if (phoneStartWith.startsWith(codeRussia)) {
                    return phone.length >= 18;
                } else if (!phoneStartWith.startsWith("+")) {
                    return phone.length >= 15;
                } else {
                    if (phoneStartWithBigger.length > 3) {
                        return phone.length >= 15;
                    } else {
                        return phone.length >= 15;
                    }
                }
        }
    };

    const formatDominicanNumber = (input) => {
        // (000) 000-000 o +1 (000) 000-000
        let countryCode = "";
        if (input.startsWith(codeUnitedState)) {
            countryCode = input.slice(0, 2);
            input = input.slice(2, 17).replace(replaceStr, "");
        } else {
            input = input.replace(/\D/g, "").substring(0, 10);
        }
        const size = input.length;
        if (size > 0) {
            input = " (" + input;
        }
        if (size > 3) {
            input = input.slice(0, 5) + ") " + input.slice(5);
        }
        if (size > 6) {
            input = input.slice(0, 10) + "-" + input.slice(10);
        }

        if (countryCode === codeUnitedState) {
            return countryCode + input;
        } else {
            return input;
        }
    };

    const formatMexicanNumber = (inputValue) => {
        // +00 (00) 0000 0000
        const countryCode = inputValue.slice(0, 3);
        let cleanedValue = inputValue.slice(3, 18).replace(replaceStr, "");
        const size = cleanedValue.length;

        if (size > 0) {
            cleanedValue = " (" + cleanedValue;
        }

        if (size > 2) {
            cleanedValue = cleanedValue.slice(0, 4) + ") " + cleanedValue.slice(4);
        }

        if (size > 6) {
            cleanedValue = cleanedValue.slice(0, 10) + " " + cleanedValue.slice(10);
        }

        return countryCode + cleanedValue;
    };

    const formatItalyNumber = (number) => {
        // +00 000 0000000
        const countryCode = number.slice(0, 3);
        let cleanedValue = number.slice(3, 15).replace(replaceStr, "");
        const size = cleanedValue.length;

        if (size > 0) {
            cleanedValue = " " + cleanedValue;
        }

        if (size > 3) {
            cleanedValue = cleanedValue.slice(0, 4) + " " + cleanedValue.slice(4);
        }

        return countryCode + cleanedValue;
    };

    const formatUnitedKingdomNumber = (number) => {
        // +00 0000 000000
        const countryCode = number.slice(0, 3);
        let cleanedValue = number.slice(3, 15).replace(replaceStr, "");
        const size = cleanedValue.length;

        if (size > 0) {
            cleanedValue = " " + cleanedValue;
        }

        if (size > 4) {
            cleanedValue = cleanedValue.slice(0, 5) + " " + cleanedValue.slice(5);
        }
        if (size > 6) {
            cleanedValue = cleanedValue.slice(0, 5) + "" + cleanedValue.slice(5);
        }

        return countryCode + cleanedValue;
    };

    const formatSpainNumber = (number) => {
        // +00 000 000 000
        const countryCode = number.slice(0, 3);
        let cleanedValue = number.slice(3, 15).replace(replaceStr, "");
        const size = cleanedValue.length;

        if (size > 0) {
            cleanedValue = " " + cleanedValue;
        }

        if (size > 3) {
            cleanedValue = cleanedValue.slice(0, 4) + " " + cleanedValue.slice(4);
        }
        if (size > 6) {
            cleanedValue = cleanedValue.slice(0, 8) + " " + cleanedValue.slice(8);
        }
        if (size > 10) {
            cleanedValue = cleanedValue.slice(0, 10) + "" + cleanedValue.slice(10);
        }

        return countryCode + cleanedValue;
    };

    const formatArgentineNumber = (inputValue) => {
        // +00 (00) 00000000
        const countryCode = inputValue.slice(0, 3);
        let cleanedValue = inputValue.slice(3, 17).replace(replaceStr, "");
        const size = cleanedValue.length;

        if (size > 0) {
            cleanedValue = " (" + cleanedValue;
        }

        if (size > 2) {
            cleanedValue = cleanedValue.slice(0, 4) + ") " + cleanedValue.slice(4);
        }

        return countryCode + cleanedValue;
    };

    const formatBrasilNumber = (inputValue) => {
        // +00 (00) 000000000
        const countryCode = inputValue.slice(0, 3);
        let cleanedValue = inputValue.slice(3, 18).replace(replaceStr, "");
        const size = cleanedValue.length;

        if (size > 0) {
            cleanedValue = " (" + cleanedValue;
        }

        if (size > 2) {
            cleanedValue = cleanedValue.slice(0, 4) + ") " + cleanedValue.slice(4);
        }

        return countryCode + cleanedValue;
    };

    const formatCubaNumber = (inputValue) => {
        // +00 0 0000000
        const countryCode = inputValue.slice(0, 3);
        let cleanedValue = inputValue.slice(3, 13).replace(replaceStr, "");
        const size = cleanedValue.length;

        if (size > 0) {
            cleanedValue = " " + cleanedValue;
        }

        if (size > 1) {
            cleanedValue = cleanedValue.slice(0, 2) + " " + cleanedValue.slice(2);
        }

        return countryCode + cleanedValue;
    };

    const formatGuatemalaNumber = (inputValue) => {
        // +000 0000 0000
        const countryCode = inputValue.slice(0, 4);
        let cleanedValue = inputValue.slice(4, 14).replace(replaceStr, "");
        const size = cleanedValue.length;

        if (size > 0) {
            cleanedValue = " " + cleanedValue;
        }

        if (size > 4) {
            cleanedValue = cleanedValue.slice(0, 5) + " " + cleanedValue.slice(5);
        }

        return countryCode + cleanedValue;
    };

    const formatBoliviaNumber = (inputValue) => {
        // +000 (0) 000-0000
        const countryCode = inputValue.slice(0, 4);
        let cleanedValue = inputValue.slice(4, 17).replace(replaceStr, "");
        const size = cleanedValue.length;

        if (size > 0) {
            cleanedValue = " (" + cleanedValue;
        }

        if (size > 1) {
            cleanedValue = cleanedValue.slice(0, 3) + ") " + cleanedValue.slice(3);
        }

        if (size > 2) {
            cleanedValue = cleanedValue.slice(0, 4) + "" + cleanedValue.slice(4);
        }

        if (size > 4) {
            cleanedValue = cleanedValue.slice(0, 8) + "-" + cleanedValue.slice(8);
        }

        return countryCode + cleanedValue;
    };

    const formatEcuadorNumber = (inputValue) => {
        // +000 00-0000-0000
        const countryCode = inputValue.slice(0, 4);
        let cleanedValue = inputValue.slice(4, 17).replace(replaceStr, "");
        const size = cleanedValue.length;

        if (size > 0) {
            cleanedValue = " " + cleanedValue;
        }

        if (size > 2) {
            cleanedValue = cleanedValue.slice(0, 3) + "-" + cleanedValue.slice(3);
        }

        if (size > 4) {
            cleanedValue = cleanedValue.slice(0, 4) + "" + cleanedValue.slice(4);
        }

        if (size > 6) {
            cleanedValue = cleanedValue.slice(0, 8) + "-" + cleanedValue.slice(8);
        }

        return countryCode + cleanedValue;
    };

    const formatFranceNumber = (inputValue) => {
        // +00 0 00 00 00 00
        const countryCode = inputValue.slice(0, 3);
        let cleanedValue = inputValue.slice(3, 17).replace(replaceStr, "");
        const size = cleanedValue.length;

        if (size > 0) {
            cleanedValue = " " + cleanedValue;
        }

        if (size > 1) {
            cleanedValue = cleanedValue.slice(0, 2) + " " + cleanedValue.slice(2);
        }

        if (size > 2) {
            cleanedValue = cleanedValue.slice(0, 3) + "" + cleanedValue.slice(3);
        }

        if (size > 3) {
            cleanedValue = cleanedValue.slice(0, 5) + " " + cleanedValue.slice(5);
        }

        if (size > 5) {
            cleanedValue = cleanedValue.slice(0, 8) + " " + cleanedValue.slice(8);
        }

        if (size > 7) {
            cleanedValue = cleanedValue.slice(0, 11) + " " + cleanedValue.slice(11);
        }

        return countryCode + cleanedValue;
    };

    const formatUruguayNumber = (inputValue) => {
        // +000 00 000 000
        const countryCode = inputValue.slice(0, 4);
        let cleanedValue = inputValue.slice(4, 15).replace(replaceStr, "");
        const size = cleanedValue.length;

        if (size > 0) {
            cleanedValue = " " + cleanedValue;
        }

        if (size > 2) {
            cleanedValue = cleanedValue.slice(0, 3) + " " + cleanedValue.slice(3);
        }

        if (size > 5) {
            cleanedValue = cleanedValue.slice(0, 7) + " " + cleanedValue.slice(7);
        }

        return countryCode + cleanedValue;
    };

    const formatPeruNumber = (inputValue) => {
        // +00 000 0000
        const countryCode = inputValue.slice(0, 3);
        let cleanedValue = inputValue.slice(3, 12).replace(replaceStr, "");
        const size = cleanedValue.length;

        if (size > 0) {
            cleanedValue = " " + cleanedValue;
        }

        if (size > 2) {
            cleanedValue = cleanedValue.slice(0, 4) + " " + cleanedValue.slice(4);
        }

        return countryCode + cleanedValue;
    };

    const formatParaguayNumber = (number) => {
        // +000 000 000000
        const countryCode = number.slice(0, 4);
        let cleanedValue = number.slice(4, 15).replace(replaceStr, "");
        const size = cleanedValue.length;

        if (size > 0) {
            cleanedValue = " " + cleanedValue;
        }

        if (size > 3) {
            cleanedValue = cleanedValue.slice(0, 4) + " " + cleanedValue.slice(4);
        }

        return countryCode + cleanedValue;
    };

    const formatHaitiNumber = (number) => {
        // +000 00 00 0000
        const countryCode = number.slice(0, 4);
        let cleanedValue = number.slice(4, 15).replace(replaceStr, "");
        const size = cleanedValue.length;

        if (size > 0) {
            cleanedValue = " " + cleanedValue;
        }

        if (size > 2) {
            cleanedValue = cleanedValue.slice(0, 3) + " " + cleanedValue.slice(3);
        }

        if (size > 4) {
            cleanedValue = cleanedValue.slice(0, 6) + " " + cleanedValue.slice(6);
        }

        return countryCode + cleanedValue;
    };

    const formatRussiaNumber = (number) => {
        // +0 (000) 000-00-00
        const countryCode = number.slice(0, 2);
        let cleanedValue = number.slice(2, 18).replace(replaceStr, "");
        const size = cleanedValue.length;

        if (size > 0) {
            cleanedValue = " (" + cleanedValue;
        }
        if (size > 3) {
            cleanedValue = cleanedValue.slice(0, 5) + ") " + cleanedValue.slice(5);
        }
        if (size > 6) {
            cleanedValue = cleanedValue.slice(0, 10) + "-" + cleanedValue.slice(10);
        }
        if (size > 8) {
            cleanedValue = cleanedValue.slice(0, 13) + "-" + cleanedValue.slice(13);
        }

        return countryCode + cleanedValue;
    };

    const formatGermanyNumber = (inputValue) => {
        // +00 00 00000000
        const countryCode = inputValue.slice(0, 3);
        let cleanedValue = inputValue.slice(3, 15).replace(replaceStr, "");
        const size = cleanedValue.length;

        if (size > 0) {
            cleanedValue = " " + cleanedValue;
        }

        if (size > 2) {
            cleanedValue = cleanedValue.slice(0, 3) + " " + cleanedValue.slice(3);
        }

        return countryCode + cleanedValue;
    };

    const formatSwitzerlandNumber = (number) => {
        // +00 00 000 00 00
        const countryCode = number.slice(0, 3);
        let cleanedValue = number.slice(3, 16).replace(replaceStr, "");
        const size = cleanedValue.length;

        if (size > 0) {
            cleanedValue = " " + cleanedValue;
        }

        if (size > 2) {
            cleanedValue = cleanedValue.slice(0, 3) + " " + cleanedValue.slice(3);
        }
        if (size > 5) {
            cleanedValue = cleanedValue.slice(0, 7) + " " + cleanedValue.slice(7);
        }
        if (size > 7) {
            cleanedValue = cleanedValue.slice(0, 10) + " " + cleanedValue.slice(10);
        }

        return countryCode + cleanedValue;
    };

    return {
        formatPhone,
        formatDominicanNumber,
        formatMexicanNumber,
        isValid,
    };
})();
